import * as Backbone from 'backbone';
import * as _ from 'underscore';
import Utils from 'front/utils/Utils';
import { SELECTORS } from '../../constants/Constants';

//Base component, most other views are inheritor from it
//can render itself and control the child components
export default class Base extends Backbone.View {
    constructor(options = {}) {
        super(options);
        // TODO Refactor options assignment and names (e.g. ANIMATION_DURATION)
        this.options = options;

        this.views = {}; // storage for child views
        this.VIEWS_TO_REGISTER = options.VIEWS_TO_REGISTER;
        this.$content = null;

        // Constants can be updated in child component
        this.ANIMATION_DURATION = 150;
        this.loaderSafeTimeout = 500; // Max loader visibility time

        this.showLoader = false;
        this.synchronousUpdate = true; // Views update params

        this.data = this.options.data; // Set data
        this.template = options.template;

        this.parent = this.options.parent;

        if (this.options.server === false) {
            this.setElement($(''));
        }

        this.saveURLParametersToCookie();
    }

    setCookie(name, value, days) {
        let expires = '';
        if (days) {
            const date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = '; expires=' + date.toUTCString();
        }
        document.cookie = name + '=' + (value || '') + expires + '; path=/';
    }

    getCookie(name) {
        const nameEQ = name + '=';
        const ca = document.cookie.split(';');
        for (let i = 0;i < ca.length;i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        }

        return null;
    }

    saveURLParametersToCookie() {
        const queryString = window.location.search.substring(1);

        // Получаем существующее значение куки
        const existingCookie = this.getCookie('parametersArrived');

        // Если куки не существует или пусто, устанавливаем новое значение
        if (!existingCookie) {
            this.setCookie('parametersArrived', queryString, 1);
        }
    }

    isRendered() {
        return !!this.$el.length;
    }

    $parent() {
        return this.parent ? this.parent.$content : null;
    }

    attach() {
        let $parent = this.$parent();

        if ($parent) {
            $parent.append(this.$el);
        }
    }

    renderData() {
        return this.data || {};
    }

    render() {
        let data = this.renderData();

        data.viewOptions = this.options;
        this.setElement(this.template && this.template.render(data) || '');
        this.attach();

        return this;
    }

    activate() {
        this.viewName && app.els.$html.attr('data-activeView', this.viewName);

        return this.loadData().then(() => {
            if (!this.isRendered() && this.$el.parents(SELECTORS.html).length === 0) {
                this.render();
            }


            this.viewsRegistration();
            this.activateLogic();
        })
            .then(() => {
                // activate child view
                let promise = Utils.createEmptyPromise();

                if (this.views) {
                    promise = Promise.all(_.map(this.views, (view) => {
                        return view.activate();
                    }));
                }


                return promise;
            });
    }

    activateLogic() {
    }

    updateViews(newView, params = {}) {
        const newViewName = params.newViewName || params.prevViewName;
        const prevView = this.getView(params.prevViewName);
        const synchronousUpdate = params.synchronousUpdate || this.synchronousUpdate;
        const duration = params.duration || this.ANIMATION_DURATION;
        this.registerView(newViewName, newView);

        if (synchronousUpdate) {
            newView.activate().then(() => {
                return Promise.all([prevView.playOut({
                    duration: duration
                }), newView.playIn({
                    duration: duration
                })]);
            })
                .then(() => {
                    return prevView.deactivate({
                        destroy: true
                    });
                });
        } else {
            prevView.playOut({
                duration: duration
            }).then(() => {
                return prevView.deactivate({
                    destroy: true
                });
            })
                .then(() => {
                    return newView.activate();
                })
                .then(() => {
                    return newView.playIn({
                        duration: duration
                    });
                });
        }
    }

    deactivate(params = {}) {
        let promise = Utils.createEmptyPromise();

        if (this.views) {
            promise = Promise.all(_.map(this.views, (view) => {
                return view.deactivate(params);
            }));
        }


        return promise.then(() => {
            if (params.destroy) {
                this.destroy();
            }
        });
    }

    destroy() {
        this.undelegateEvents();
        this.$el.removeData().unbind();
        this.remove();
    }

    viewsRegistration() {
        const viewsToRegister = this.VIEWS_TO_REGISTER || {}; //create an individual instances of all listed inside VIEWS_TO_REGISTER items

        _.each(viewsToRegister, (params, viewName) => {
            this.$(params.selector).each((ind, item) => {
                //skip if found inside popup content when we are searching only for page content
                if ($(item).closest('.Section-content').length && this.$el.hasClass('Section')) {
                    return;
                }

                const data = {
                    el: item
                };
                this.registerView(viewName + (ind ? ' ' + ind : ''), new params.viewConstructor(data));
            });
        });
    }

    // Method to store subview in views storage object.
    // All views should be created using this method.
    registerView(viewName, view) {
        view.parent = this;
        this.views[viewName] = view;

        return view;
    }

    addView(view) {
        this.views.push(view);
    }

    getView(viewName) {
        return this.views[viewName];
    }

    destroyView(viewName) {
        this.views[viewName].destroy();
        delete this.views[viewName];
    }

    //to override in descendants
    proceedDataOnLoad(data) {
        this.data = data[0];
    }

    onDataLoadStart() {
        if (!this.showLoader) {
            return;
        }


        if (this.isLoading) {
            return;
        }


        this.isLoading = true;
        this.loaderTimeout = setTimeout(() => {
            // loader logic here (e.g. add visible class to spinner animated loader)
        }, this.loaderSafeTimeout);
    }

    onDataLoadEnd() {
        if (!this.showLoader) {
            return;
        }


        if (!this.isLoading) {
            return;
        }


        this.isLoading = false;
        clearTimeout(this.loaderTimeout);
        // loader logic here (e.g. remove visible class to spinner animated loader)
    }

    fetchData(apiUrl) {
        const urls = _.isArray(apiUrl) ? apiUrl : [apiUrl];

        return Promise.all(_.map(urls, (url) => {
            return Promise.resolve($.getJSON(url));
        })).then((data) => {
            this.proceedDataOnLoad(data);
            this.onDataLoadEnd();
        })
            .catch(() => {
                console.error('Error loading data');
                this.onDataLoadEnd(); // app.router.navigateBack();
            });
    }

    forceLoadData(apiUrl) {
        let api;
        apiUrl = apiUrl || this.apiUrl;

        if (apiUrl) {
            api = _.isFunction(apiUrl) ? apiUrl() : apiUrl;
            this.onDataLoadStart();

            return this.fetchData(api);
        } else {
            return Utils.createEmptyPromise();
        }
    }

    loadData() {
        const apiUrl = _.isFunction(this.apiUrl) ? this.apiUrl() : this.apiUrl;

        if (!this.data && apiUrl) {
            if (!this.disableCache) {
                //is caching is allowed then cache it and return
                if (window.app.cache[apiUrl] !== undefined) {
                    this.data = window.app.cache[apiUrl];

                    return Utils.createEmptyPromise();
                }

                return this.forceLoadData(apiUrl).then(() => {
                    window.app.cache[apiUrl] = this.data;
                });
            } else {
                return this.forceLoadData(apiUrl);
            }
        } else {
            return Utils.createEmptyPromise();
        }
    }

    //method for animation logic on component activation
    playIn() {
        // empty Promise, signal that method is done his work
        return Utils.createEmptyPromise();
    }

    //method for animation logic on component deactivation
    playOut() {
        // empty Promise, signal that method is done his work
        return Utils.createEmptyPromise();
    }
}
